var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"bg-[#EBECF6] p-2 uppercase rounded px-2 py-1 text-sm font-semibold"},[_vm._v("\n    Beta\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }